var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -14,
    y: -14,
    width: 68,
    height: 68
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7px)",
      clipPath: "url(#bgblur_0_949_85_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.7778V27.7778C10 29.0051 10.9949 30 12.2222 30H27.7778C29.0051 30 30 29.0051 30 27.7778V17.7778",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.7778V27.7778C10 29.0051 10.9949 30 12.2222 30H27.7778C29.0051 30 30 29.0051 30 27.7778V17.7778",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1481 30V23.3334C23.1481 22.106 22.1532 21.1111 20.9259 21.1111H18.7037C17.4764 21.1111 16.4814 22.106 16.4814 23.3334V30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1481 30V23.3334C23.1481 22.106 22.1532 21.1111 20.9259 21.1111H18.7037C17.4764 21.1111 16.4814 22.106 16.4814 23.3334V30",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9092 17.0713L29.027 10.4835C28.9452 10.1973 28.6837 10 28.386 10H23.8889L24.417 16.3375C24.4344 16.5449 24.547 16.7323 24.7258 16.8388C25.1584 17.0966 26.0058 17.5744 26.6667 17.7778C27.7954 18.125 29.4454 17.9998 30.385 17.8842C30.7758 17.8362 31.0175 17.4499 30.9092 17.0713Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9092 17.0713L29.027 10.4835C28.9452 10.1973 28.6837 10 28.386 10H23.8889L24.417 16.3375C24.4344 16.5449 24.547 16.7323 24.7258 16.8388C25.1584 17.0966 26.0058 17.5744 26.6667 17.7778C27.7954 18.125 29.4454 17.9998 30.385 17.8842C30.7758 17.8362 31.0175 17.4499 30.9092 17.0713Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 17.7778C22.8528 17.5838 23.6532 17.1399 24.101 16.8756C24.3142 16.7498 24.4316 16.5123 24.411 16.2656L23.8889 10H16.1111L15.589 16.2656C15.5684 16.5123 15.6858 16.7498 15.899 16.8756C16.3468 17.1399 17.1472 17.5838 17.7778 17.7778C19.4367 18.2882 20.5633 18.2882 22.2222 17.7778Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 17.7778C22.8528 17.5838 23.6532 17.1399 24.101 16.8756C24.3142 16.7498 24.4316 16.5123 24.411 16.2656L23.8889 10H16.1111L15.589 16.2656C15.5684 16.5123 15.6858 16.7498 15.899 16.8756C16.3468 17.1399 17.1472 17.5838 17.7778 17.7778C19.4367 18.2882 20.5633 18.2882 22.2222 17.7778Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.973 10.4835L9.09076 17.0713C8.98259 17.4499 9.22425 17.8362 9.61503 17.8842C10.5546 17.9998 12.2047 18.125 13.3334 17.7778C13.9942 17.5744 14.8417 17.0966 15.2742 16.8388C15.453 16.7323 15.5657 16.5449 15.583 16.3375L16.1111 10H11.614C11.3163 10 11.0548 10.1973 10.973 10.4835Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.973 10.4835L9.09076 17.0713C8.98259 17.4499 9.22425 17.8362 9.61503 17.8842C10.5546 17.9998 12.2047 18.125 13.3334 17.7778C13.9942 17.5744 14.8417 17.0966 15.2742 16.8388C15.453 16.7323 15.5657 16.5449 15.583 16.3375L16.1111 10H11.614C11.3163 10 11.0548 10.1973 10.973 10.4835Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_949_85_clip_path",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailIcon);
export default __webpack_public_path__ + "static/media/retail-icon.5ac7d208edd9eb707fbb79fb8522937f.svg";
export { ForwardRef as ReactComponent };